import { render, staticRenderFns } from "./audienceInfo.vue?vue&type=template&id=3109fdf5&scoped=true&"
import script from "./audienceInfo.vue?vue&type=script&lang=js&"
export * from "./audienceInfo.vue?vue&type=script&lang=js&"
import style0 from "./audienceInfo.vue?vue&type=style&index=0&id=3109fdf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3109fdf5",
  null
  
)

export default component.exports